var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _path28, _path29, _g2, _path30, _path31, _path32, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTourbus = function SvgIconTourbus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 104,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-tourbus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__b)",
    fillOpacity: 0.8,
    d: "M60 72.571c33.137 0 60 1.152 60 2.572s-26.863 2.571-60 2.571-60-1.151-60-2.571 26.863-2.572 60-2.572",
    style: {
      mixBlendMode: "multiply"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M93.52 69.692c0 3.33-2.669 6.029-5.962 6.029s-5.962-2.7-5.962-6.03 2.67-6.029 5.962-6.029c3.293 0 5.963 2.7 5.963 6.03M51.71 69.692c0 3.33-2.67 6.03-5.962 6.03-3.293 0-5.963-2.7-5.963-6.03s2.67-6.03 5.963-6.03 5.962 2.7 5.962 6.03"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__c)",
    d: "M104.899 56.292c-.467-8.55-1.579-12.952-3.033-17.731-1.454-4.79-1.516-7.479-8.788-7.479H15.79c-2.046 0-2.948 1.938-3.748 4.46 22.739 0 61.194.01 63.79.01 3.46 0 3.105 7.84 3.23 18.177.051 4.327.083 10.556.103 16.565l24.489-.042s1.683-5.736 1.236-13.96z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__d)",
    fillOpacity: 0.2,
    d: "M104.899 56.292c-.467-8.55-1.579-12.952-3.033-17.731-1.454-4.79-1.516-7.479-8.788-7.479H15.79c-2.046 0-2.948 1.938-3.748 4.46 22.739 0 61.194.01 63.79.01 3.46 0 3.105 7.84 3.23 18.177.051 4.327.083 10.556.103 16.565l24.489-.042s1.683-5.736 1.236-13.96z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__e)",
    fillOpacity: 0.2,
    d: "M104.899 56.292c-.467-8.55-1.579-12.952-3.033-17.731-1.454-4.79-1.516-7.479-8.788-7.479H15.79c-2.046 0-2.948 1.938-3.748 4.46 22.739 0 61.194.01 63.79.01 3.46 0 3.105 7.84 3.23 18.177.051 4.327.083 10.556.103 16.565l24.489-.042s1.683-5.736 1.236-13.96z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__f)",
    d: "M76.108 35.067c-2.605 0-41.194 0-63.996-.01-.343 1.07-.471 2.372-.52 4.05-.28 9.47-.08 27.287-.08 27.287l3.706 4.422 64.079-.105c-.02-6.002.031-18.319-.02-22.642-.136-10.325.301-13.013-3.169-13.013z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__g)",
    fillOpacity: 0.3,
    d: "M76.108 35.067c-2.605 0-41.194 0-63.996-.01-.343 1.07-.471 2.372-.52 4.05-.28 9.47-.08 27.287-.08 27.287l3.706 4.422 64.079-.105c-.02-6.002.031-18.319-.02-22.642-.136-10.325.301-13.013-3.169-13.013z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__h)",
    fillOpacity: 0.2,
    d: "M76.108 35.067c-2.605 0-41.194 0-63.996-.01-.343 1.07-.471 2.372-.52 4.05-.28 9.47-.08 27.287-.08 27.287l3.706 4.422 64.079-.105c-.02-6.002.031-18.319-.02-22.642-.136-10.325.301-13.013-3.169-13.013z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#24262C",
    d: "M34.732 69.156h-2.515c-.805 4.874-5.366 7.446-7.043 7.616 8.05.507 9.223-5.585 9.558-7.616M75.983 70.68h-2.648c-.847 4.16-5.648 5.92-7.413 6.065 8.472.433 9.708-4.332 10.061-6.064"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__i)",
    d: "M103.661 70.249s-83.418-1.387-87.573-1.387-4.498-2.52-4.498-2.52-1.111 4.054 5.132 5.483c3.636.83 66.59.724 82.109.724 1.714 0 3.531-.714 4.705-1.974l.301-.326z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__j)",
    d: "M69.56 49.958v20.054l9.742.096V58.492l-3.576-.632c-1.305-.326-2.554-2.119-2.892-3.2l-1.318-2.594c-.458-1.193-1.13-1.6-1.957-2.105z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#323443",
    d: "M70.152 55.028h.928v2.6h-.928z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__k)",
    d: "m69.556 36.329.003 13.634c.806.497 1.433 1.03 1.813 2.012l1.414 2.841c.916 1.82 1.736 2.831 3.525 3.336 1.79.504 2.994.46 2.994.46L79.22 41.41h-1.036c-.676 0-1.342-.31-1.784-.744l-2.863-3.055c-1.009-1.02-1.763-1.282-2.645-1.282z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C94545",
    d: "m11.443 60.664 1.302.058c.058.002.103.05.103.108v2.865c0 .06-.048.108-.108.108h-1.303a.1.1 0 0 1-.101-.08c-.035-.178-.11-.652-.11-1.462 0-.812.075-1.321.11-1.514a.103.103 0 0 1 .107-.083"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__l)",
    d: "m11.514 66.342 92.858.393s-.081.965-.217 1.836c-.136.87-.327 1.685-.327 1.685l-91.242-.547s-.405-.257-.678-.725c-.272-.468-.394-1.274-.394-1.274z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__m)",
    d: "M32.355 69.145c0 4.195-3.257 7.605-7.266 7.605s-7.266-3.398-7.266-7.605 3.256-7.605 7.266-7.605 7.266 3.398 7.266 7.605"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__n)",
    d: "M25.09 74.092c2.7 0 4.89-2.214 4.89-4.945s-2.19-4.945-4.89-4.945c-2.702 0-4.891 2.213-4.891 4.945 0 2.73 2.19 4.944 4.89 4.944"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__o)",
    stroke: "url(#icon-tourbus_svg__p)",
    strokeWidth: 0.083,
    d: "M23.844 69.143c0-.692.561-1.259 1.244-1.259.684 0 1.245.567 1.245 1.259s-.561 1.259-1.244 1.259a1.256 1.256 0 0 1-1.245-1.259Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__q)",
    d: "M73.908 69.145c0 4.195-3.256 7.605-7.265 7.605s-7.266-3.398-7.266-7.605 3.256-7.605 7.266-7.605 7.265 3.398 7.265 7.605"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__r)",
    d: "M66.642 74.092c2.7 0 4.89-2.214 4.89-4.945s-2.19-4.945-4.89-4.945-4.89 2.213-4.89 4.945c0 2.73 2.19 4.944 4.89 4.944"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__s)",
    stroke: "url(#icon-tourbus_svg__t)",
    strokeWidth: 0.083,
    d: "M66.642 67.8a1.34 1.34 0 0 0-1.328 1.343 1.34 1.34 0 0 0 1.328 1.342 1.34 1.34 0 0 0 1.328-1.342 1.34 1.34 0 0 0-1.328-1.342Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.816,
    height: 3.027,
    x: 88.612,
    y: 67.785,
    fill: "url(#icon-tourbus_svg__u)",
    rx: 0.216
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#131627",
    d: "M88.612 68.001c0-.12.097-.216.217-.216h9.233v2.397c0 .12-.097.216-.216.216h-9.234zM69.14 36.329H17.277a.417.417 0 0 0-.417.416v12.822c0 .23.186.417.417.417H69.14c.23 0 .417-.187.417-.417V36.746a.417.417 0 0 0-.417-.417"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__v)",
    d: "M33.575 36.329H16.859v13.655h16.716z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__w)",
    fillOpacity: 0.2,
    d: "M33.575 36.329H16.859v13.655h16.716z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__x)",
    d: "M53.655 36.329H34.733v13.655h18.922z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__y)",
    fillOpacity: 0.2,
    d: "M53.655 36.329H34.733v13.655h18.922z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__z)",
    d: "M71.08 36.329H54.85v13.655H71.08z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__A)",
    fillOpacity: 0.2,
    d: "M71.08 36.329H54.85v13.655H71.08z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-tourbus_svg__C",
    width: 11,
    height: 23,
    x: 69,
    y: 36,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__B)",
    d: "M69.561 36.329v13.674c.16 0 1.294.703 1.737 1.807l1.687 3.058c.486 1.048 1.572 2.729 2.816 3.046 0 0 2.353.777 3.464.701l-.028-17.203h-1.202c-.664 0-1.177-.366-1.627-.845l-2.937-3.024c-.822-.95-1.758-1.214-2.624-1.214z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#131627",
    mask: "url(#icon-tourbus_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.292 41.125h1.01v17.712h-1.01zM69.557 35.596h1.01v17.712h-1.01z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "icon-tourbus_svg__G",
    width: 93,
    height: 40,
    x: 12,
    y: 30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__D)",
    d: "M104.898 55.781c-.467-8.55-1.579-12.951-3.033-17.73-1.454-4.79-1.517-7.48-8.788-7.48h-77.29c-2.046 0-2.947 1.939-3.747 4.46 22.739 0 61.194.01 63.79.01 3.46 0 3.105 7.841 3.23 18.177.051 4.328.082 10.557.103 16.565l24.653.15s1.401-6.041 1.072-14.152z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__E)",
    fillOpacity: 0.2,
    d: "M104.898 55.781c-.467-8.55-1.579-12.951-3.033-17.73-1.454-4.79-1.517-7.48-8.788-7.48h-77.29c-2.046 0-2.947 1.939-3.747 4.46 22.739 0 61.194.01 63.79.01 3.46 0 3.105 7.841 3.23 18.177.051 4.328.082 10.557.103 16.565l24.653.15s1.401-6.041 1.072-14.152z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__F)",
    fillOpacity: 0.2,
    d: "M104.898 55.781c-.467-8.55-1.579-12.951-3.033-17.73-1.454-4.79-1.517-7.48-8.788-7.48h-77.29c-2.046 0-2.947 1.939-3.747 4.46 22.739 0 61.194.01 63.79.01 3.46 0 3.105 7.841 3.23 18.177.051 4.328.082 10.557.103 16.565l24.653.15s1.401-6.041 1.072-14.152z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-tourbus_svg__G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__H)",
    d: "m79.156 41.407.091 17.216 30.954.268c0-5.913-.601-10.604-2.203-16.779l-28.844-.705z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "icon-tourbus_svg__L",
    width: 84,
    height: 36,
    x: 12,
    y: 30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__I)",
    d: "M95.527 53.254c-.42-7.693-1.66-11.997-2.969-16.298-1.308-4.31-1.125-6.385-7.667-6.385H15.349c-2.057.299-2.967 2.627-3.324 4.078 20.46 0 55.968.225 58.305.225 3.112 0 1.836 6.774 1.948 16.074.047 3.894.075 9.499.094 14.905l22.182.135s1.26-5.436.964-12.734z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__J)",
    fillOpacity: 0.2,
    d: "M95.527 53.254c-.42-7.693-1.66-11.997-2.969-16.298-1.308-4.31-1.125-6.385-7.667-6.385H15.349c-2.057.299-2.967 2.627-3.324 4.078 20.46 0 55.968.225 58.305.225 3.112 0 1.836 6.774 1.948 16.074.047 3.894.075 9.499.094 14.905l22.182.135s1.26-5.436.964-12.734z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__K)",
    fillOpacity: 0.2,
    d: "M95.527 53.254c-.42-7.693-1.66-11.997-2.969-16.298-1.308-4.31-1.125-6.385-7.667-6.385H15.349c-2.057.299-2.967 2.627-3.324 4.078 20.46 0 55.968.225 58.305.225 3.112 0 1.836 6.774 1.948 16.074.047 3.894.075 9.499.094 14.905l22.182.135s1.26-5.436.964-12.734z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-tourbus_svg__L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-tourbus_svg__M)",
    d: "M11.881 29.428h80.73l4.818 5.827-29.86.395-58.44 1.562z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__c",
    x1: 80.671,
    x2: 107.376,
    y1: 41.586,
    y2: 61.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__d",
    x1: 10.554,
    x2: 98.33,
    y1: 32.658,
    y2: 33.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__e",
    x1: 117.547,
    x2: 99.155,
    y1: 22.154,
    y2: 41.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__f",
    x1: 81.318,
    x2: 11.368,
    y1: 80.343,
    y2: 52.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#D8D9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__g",
    x1: 49.013,
    x2: 40.566,
    y1: 87.164,
    y2: 46.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22232C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#D6D8EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__h",
    x1: 41.197,
    x2: 41.725,
    y1: 81.393,
    y2: 58.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#515571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8AEDB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__i",
    x1: 36.215,
    x2: 132.828,
    y1: 70.239,
    y2: 69.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__j",
    x1: 69.559,
    x2: 79.302,
    y1: 59.264,
    y2: 59.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#E2E2E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__k",
    x1: 79.305,
    x2: 69.556,
    y1: 48.083,
    y2: 45.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E303F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__l",
    x1: 77.817,
    x2: 43.067,
    y1: 67.801,
    y2: 85.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#32B9E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__m",
    x1: 25.089,
    x2: 25.089,
    y1: 61.54,
    y2: 76.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__n",
    x1: 25.089,
    x2: 25.089,
    y1: 64.202,
    y2: 74.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#AAACBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__o",
    x1: 25.088,
    x2: 25.088,
    y1: 70.444,
    y2: 67.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAACBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__p",
    x1: 25.088,
    x2: 25.088,
    y1: 70.444,
    y2: 67.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__q",
    x1: 66.643,
    x2: 66.643,
    y1: 61.54,
    y2: 76.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__r",
    x1: 66.642,
    x2: 66.642,
    y1: 64.202,
    y2: 74.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#AAACBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__s",
    x1: 66.642,
    x2: 66.642,
    y1: 70.444,
    y2: 67.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAACBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__t",
    x1: 66.642,
    x2: 66.642,
    y1: 70.444,
    y2: 67.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__u",
    x1: 93.52,
    x2: 93.52,
    y1: 67.785,
    y2: 70.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D4DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__v",
    x1: 32.483,
    x2: 17.642,
    y1: 44.947,
    y2: 44.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__w",
    x1: 25.217,
    x2: 25.217,
    y1: 38.429,
    y2: 43.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D303D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__x",
    x1: 53.811,
    x2: 34.465,
    y1: 44.947,
    y2: 44.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__y",
    x1: 44.194,
    x2: 44.194,
    y1: 38.429,
    y2: 43.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D303D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__z",
    x1: 81.407,
    x2: 55.517,
    y1: 44.947,
    y2: 44.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__A",
    x1: 65.088,
    x2: 65.088,
    y1: 38.429,
    y2: 43.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D303D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__B",
    x1: 79.315,
    x2: 69.714,
    y1: 48.085,
    y2: 45.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E303F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3F52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__D",
    x1: 80.669,
    x2: 107.375,
    y1: 41.075,
    y2: 61.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__E",
    x1: 10.553,
    x2: 98.329,
    y1: 32.147,
    y2: 32.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__F",
    x1: 117.546,
    x2: 99.153,
    y1: 21.643,
    y2: 40.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__H",
    x1: 80.291,
    x2: 97.804,
    y1: 44.272,
    y2: 51.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F7396"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__I",
    x1: 73.727,
    x2: 97.756,
    y1: 40.023,
    y2: 58.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__J",
    x1: 10.638,
    x2: 89.616,
    y1: 31.989,
    y2: 32.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__K",
    x1: 106.907,
    x2: 90.359,
    y1: 22.538,
    y2: 39.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E4F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-tourbus_svg__M",
    x1: 91.153,
    x2: 14.088,
    y1: 33.32,
    y2: 30.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#F3F3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#ECECF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F5F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-tourbus_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(59.8114 0 0 2.5646 59.894 75.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-tourbus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 81.699h120v-9.696H0z"
  })))));
};
export default SvgIconTourbus;